/**
 * Whether an image URL points into our own Firebase Storage bucket — i.e. it
 * can't disappear because someone else's site went away.
 *
 * Covers both URL shapes Storage hands out: the download URL
 * (`firebasestorage.googleapis.com/v0/b/{bucket}/o/...`) and the public GCS
 * URL (`storage.googleapis.com/{bucket}/...`). Pure; the bucket is passed in so
 * it is testable (the app passes VITE_FIREBASE_STORAGE_BUCKET).
 */
export function isOwnStorageUrl(url: string, bucket: string | undefined): boolean {
  const b = (bucket ?? '').trim();
  if (!b) return false;
  let u: URL;
  try {
    u = new URL(url.trim());
  } catch {
    return false;
  }
  if (u.hostname === 'firebasestorage.googleapis.com') {
    return u.pathname.startsWith(`/v0/b/${b}/o/`);
  }
  if (u.hostname === 'storage.googleapis.com') {
    return u.pathname.startsWith(`/${b}/`);
  }
  return false;
}
